<template>
  <div class="login-root">
    <div class="login-shell">

      <!-- Form panel -->
      <div class="login-panel">
        <div class="login-panel__inner">
          <img src="@/assets/images/default.jpg" class="login-logo" alt="Logo">

          <h1 class="login-title">Welcome back</h1>
          <p class="login-subtitle">Please sign in to continue.</p>

          <small v-if="error" class="login-error"><b>{{ error }}</b></small>

          <form @submit.prevent="login" class="login-form">
            <div class="field">
              <label class="field__label">Username</label>
              <base-input alternative placeholder="Username" addon-left-icon="ni ni-single-02" v-model="username">
              </base-input>
            </div>

            <div class="field">
              <label class="field__label">Password</label>
              <div class="pw-input">
                <span class="pw-input__icon"><i class="ni ni-lock-circle-open"></i></span>
                <input :type="passwordVisible ? 'text' : 'password'" class="pw-input__field"
                  placeholder="Password" aria-label="Password" v-model="password" />
                <span @click.prevent="togglePassword" class="pw-input__toggle">
                  <i :class="passwordVisible ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                </span>
              </div>
            </div>

            <button type="submit" class="login-btn" :disabled="!username || !password">
              <Spinner :is-active="login_loader" :default-text="'Sign In'" />
            </button>
          </form>
        </div>
      </div>

      <!-- Image panel -->
      <div class="login-visual">
        <img src="@/assets/images/bana.jpeg" alt="" class="login-visual__img">
        <div class="login-visual__overlay"></div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Spinner from '@/components/Spinner.vue'

export default {
  data() {
    return {
      username: '',
      password: '',
      login_loader: false,
      passwordVisible: false,
    }
  },
  components: {
    Spinner
  },

  methods: {
    togglePassword() {
      this.passwordVisible = !this.passwordVisible
    },
    async login() {
      this.login_loader = true;
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);
      let url = "/login";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          let userData = response.data.user;
          let token = response.data.token;
          let financialyear = response.data.financialyear;
          let license = response.data.license;
          let branches = response.data.branches;
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          localStorage.setItem("user", JSON.stringify(userData));
          localStorage.setItem("token", token);
          localStorage.setItem("financialyear", financialyear);
          localStorage.setItem("license", license);
          localStorage.setItem("branches", JSON.stringify(branches));

          // checks for a valid license
          const end_date = new Date(localStorage.getItem('license'))
          const today = new Date()
          if (end_date < today) {
            localStorage.setItem('active_license', 0)
          } else {
            localStorage.setItem('active_license', 1)
          }
          // end

          if (branches.length > 1) {
            this.$router.push('/choose_branch')
          } else {
            if (end_date < today) {
              this.$router.push('/subscriptions')
              this.$toast.error('Your License has expired!')

              this.$router.beforeEach((to, from, next) => {
                next(false);
              });
            } else {
              this.$router.push(
                this.$route.query.redirectFrom || { name: "default" }
              );
            }
          }
        } else {
          // this.error = response.data.message;
          this.error = "Invalid username or password";
          this.login_loader = false;
        }
      });
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500;600;700&family=Inter:wght@400;500;600&display=swap');

.login-root {
  --ink: #0B1220;
  --ink-soft: #64748B;
  --bg: #F5F7FA;
  --surface: #FFFFFF;
  --border: #E6E9EF;
  --accent: #0E7C66;
  --accent-soft: #E4F5F0;
  min-height: 100vh;
  width: 100%;
  background: var(--bg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  color: var(--ink);
  padding: 24px;
}

.login-shell {
  width: 100%;
  max-width: 1000px;
  min-height: 620px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(11, 18, 32, 0.06);
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;
}

@media (max-width: 860px) {
  .login-shell {
    grid-template-columns: 1fr;
  }
}

/* ---------- Form panel ---------- */
.login-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
}

.login-panel__inner {
  width: 100%;
  max-width: 340px;
}

.login-logo {
  height: 56px;
  border-radius: 10px;
  display: block;
  margin-bottom: 28px;
}

.login-title {
  font-family: 'Sora', sans-serif;
  font-weight: 700;
  font-size: 1.6rem;
  margin: 0 0 6px;
  color: var(--ink);
}

.login-subtitle {
  font-size: 0.9rem;
  color: var(--ink-soft);
  margin: 0 0 22px;
}

.login-error {
  display: block;
  background: #FDECEA;
  color: #B3261E;
  border: 1px solid #F6C6C2;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.82rem;
  margin-bottom: 16px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field__label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.field ::v-deep .form-control {
  border-radius: 10px;
  border: 1px solid var(--border);
  padding: 10px 14px;
  box-shadow: none;
}

.field ::v-deep .form-control:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.pw-input {
  display: flex;
  align-items: center;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.pw-input:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.pw-input__icon {
  padding: 0 0 0 14px;
  color: var(--ink-soft);
  display: flex;
  align-items: center;
}

.pw-input__field {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px 12px;
  font-size: 0.9rem;
  background: transparent;
  color: var(--ink);
}

.pw-input__toggle {
  padding: 0 14px;
  color: var(--ink-soft);
  cursor: pointer;
  display: flex;
  align-items: center;
}

.pw-input__toggle:hover {
  color: var(--accent);
}

.login-btn {
  margin-top: 6px;
  width: 100%;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px 0;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.login-btn:hover:not(:disabled) {
  opacity: 0.92;
}

.login-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ---------- Visual panel ---------- */
.login-visual {
  position: relative;
  display: none;
}

@media (min-width: 861px) {
  .login-visual {
    display: block;
  }
}

.login-visual__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.login-visual__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(11, 18, 32, 0) 40%, rgba(11, 18, 32, 0.35) 100%);
}
</style>